import global from "global";

let clientConfiguration;
const clientConfigurationProvider = () => {
  if (!clientConfiguration) {
    clientConfiguration = global.asos.savedLists._clientConfiguration;
    delete global.asos.savedLists._clientConfiguration;
  }

  return clientConfiguration;
};

export default clientConfigurationProvider;
